import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from 'store/modules/listing/actionTypes';

import { uploadDocument } from './utils';

export default function* listenUploadDocument() {
  yield takeEvery(actionTypes.UPLOAD_DOCUMENT, uploadDocument);
}
